/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { IdsList } from '../model/idsList';
import { ProperNameCrudRequestResponse } from '../model/properNameCrudRequestResponse';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class ProperNameService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * Delete proper_names
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsDeleteProperName(
    body?: IdsList,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public cmsDeleteProperName(
    body?: IdsList,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public cmsDeleteProperName(
    body?: IdsList,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public cmsDeleteProperName(
    body?: IdsList,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>(
      'post',
      `${this.basePath}/cms/proper_names/delete`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Get all proper names
   * @param first_name_contains First name
   * @param last_name_contains Last name
   * @param date_of_birth Date of birth
   * @param date_of_death Date of death
   * @param sort_by Sort by
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsGetProperName(
    first_name_contains?: string,
    last_name_contains?: string,
    date_of_birth?: string,
    date_of_death?: string,
    sort_by?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ProperNameCrudRequestResponse>;
  public cmsGetProperName(
    first_name_contains?: string,
    last_name_contains?: string,
    date_of_birth?: string,
    date_of_death?: string,
    sort_by?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ProperNameCrudRequestResponse>>;
  public cmsGetProperName(
    first_name_contains?: string,
    last_name_contains?: string,
    date_of_birth?: string,
    date_of_death?: string,
    sort_by?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ProperNameCrudRequestResponse>>;
  public cmsGetProperName(
    first_name_contains?: string,
    last_name_contains?: string,
    date_of_birth?: string,
    date_of_death?: string,
    sort_by?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (first_name_contains !== undefined && first_name_contains !== null) {
      queryParameters = queryParameters.set(
        'first_name_contains',
        <any>first_name_contains
      );
    }
    if (last_name_contains !== undefined && last_name_contains !== null) {
      queryParameters = queryParameters.set(
        'last_name_contains',
        <any>last_name_contains
      );
    }
    if (date_of_birth !== undefined && date_of_birth !== null) {
      queryParameters = queryParameters.set(
        'date_of_birth',
        <any>date_of_birth
      );
    }
    if (date_of_death !== undefined && date_of_death !== null) {
      queryParameters = queryParameters.set(
        'date_of_death',
        <any>date_of_death
      );
    }
    if (sort_by !== undefined && sort_by !== null) {
      queryParameters = queryParameters.set('sort_by', <any>sort_by);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ProperNameCrudRequestResponse>(
      'get',
      `${this.basePath}/cms/proper_names`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Create a new record of type &#x27;ProperName&#x27;
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsPostProperName(
    body?: ProperNameCrudRequestResponse,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ProperNameCrudRequestResponse>;
  public cmsPostProperName(
    body?: ProperNameCrudRequestResponse,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ProperNameCrudRequestResponse>>;
  public cmsPostProperName(
    body?: ProperNameCrudRequestResponse,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ProperNameCrudRequestResponse>>;
  public cmsPostProperName(
    body?: ProperNameCrudRequestResponse,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ProperNameCrudRequestResponse>(
      'post',
      `${this.basePath}/cms/proper_names`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
